/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    number,
    object, string,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

const styles = (theme) => ({
    bannerInner: {
        padding: '0 20px 40px 20px',
    },
    title: {
        position: 'absolute',
        top: '37%',
        textAlign: 'center',
        width: '100%',
        fontSize: '30px',
        lineHeight: '30px',
        color: theme.palette.white,
        fontWeight: 'bold',
        [theme.breakpoints.down('md')]: {
            fontSize: '22px',
        },
    },
    bannerInnerImg: {
        position: 'relative',
    },
    bannerImg: {
        display: 'block',
        width: '100%',
    },
    shopBtn: {
        display: 'block',
        padding: '4px 10px',
        border: '2px solid',
        width: '150px',
        margin: '0 auto',
        marginTop: '15px',
        fontSize: '14px',
        textTransform: 'uppercase',
    },
    showAsOne: {
        '& $title': {
            top: '50%',
            fontSize: '35px',
        },
    },
    showAsTwo: {
        '& $title': {
            top: '37%',
            fontSize: '30px',
        },
    },
    showAsThree: {
        '& $title': {
            top: '25%',
            fontSize: '25px',
        },
    },
    showAsFour: {
        '& $title': {
            top: '10%',
            fontSize: '20px',
        },
    },
});

const GiftBlockBanner = ({
    classes, title, link, imgUrl, imgTitle, bannerAcross,
}) => {
    const desktopBanners = bannerAcross ? 12 / bannerAcross : 6;
    // Display desktop banner per row on the basis of the banner across field
    const bannerPerRow = () => {
        switch (bannerAcross) {
            case 1:
                return classes.showAsOne;
            case 2:
                return classes.showAsTwo;
            case 3:
                return classes.showAsThree;
            default:
                return classes.showAsFour;
        }
    };

    return (

        <Grid item md={desktopBanners}>
            <div className={`${bannerPerRow()} ${classes.bannerInner}`}>
                <div className={classes.bannerInnerImg}>
                    <Link to={link}>
                        <img src={imgUrl} alt={imgTitle} className={classes.bannerImg} />
                        <div className={classes.title}> {title}
                            <span className={classes.shopBtn}>Shop now</span>
                        </div>
                    </Link>
                </div>
            </div>
        </Grid>
    );
};

GiftBlockBanner.propTypes = {
    classes: object.isRequired,
    title: string.isRequired,
    link: string.isRequired,
    imgUrl: string.isRequired,
    imgTitle: string.isRequired,
    bannerAcross: number.isRequired,
};
export default withStyles(styles)(GiftBlockBanner);
